import { createFileRoute, Outlet } from "@tanstack/react-router";
import type { FC } from "react";
import { showQuotation } from "../../../../../__generated__/orval/endpoints/quotations/quotations";
import { ForbiddenError } from "../../../../../errors/ForbiddenError";

const RouteComponent: FC = () => {
  return <Outlet />;
};

export const Route = createFileRoute(
  "/_private/vbuyer/quotations/$quotationId",
)({
  beforeLoad({ context }) {
    if (context.auth.user?.roles_names.includes("View Quotations")) {
      return;
    }

    throw new ForbiddenError();
  },
  component: RouteComponent,
  loader: ({ params: { quotationId } }) =>
    showQuotation(parseInt(quotationId, 10)),
});
